import React, { Component } from 'react';
import { toast } from 'react-toastify';
import moment from 'moment';
import {
  ProgressIndicator,
  ProgressIndicatorSkeleton,
  ProgressStep,
  Modal,
  Loading,
  DatePicker,
  DatePickerInput
} from 'carbon-components-react';
import { Breadcrumb } from '../../../../../components';
import { getByDmService, pathDmService } from '../../../../../services/Api';
import { getStatusUniformIndex } from '../../../../../utils/modifiers';

import Detail from './Detail';
import {
  PENDENTE,
  PREPARACAO,
  PRONTAENTREGA,
  ENTREGUE,
  AGUARDANDODEVOLUCAO,
  DEVOLVIDO,
  CANCELADO,
  namesStatus
} from '../../../../../config/StatusRequest';

class Main extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      isLoading: true,
      isUpdating: false,
      openMdStatus: false,
      cancelModal: false,
      updateEntregue: false,
      nomeRecebedor: '',
      dataEntrega: ''
    };
  }

  componentDidMount() {
    const user = JSON.parse(localStorage.getItem('user'));
    const nivel = (user.nivel || {}).id;
    this.setState({nivel});

    this.loadUniforms();
  }

  loadUniforms = async () => {
    const { match } = this.props;

    try {
      const data = await getByDmService(
        '/Pedido/GetAssistente',
        match.params.id
      );
      this.setState({ 
        data, 
        dataEntrega: data.dataRetiradaUniforme || "", 
        dataBanco: data.dataRetiradaUniforme || "", 
        isLoading: false });
    } catch (e) {
      toast.error('Ocorreu um erro ao carregar a campanha');
      this.setState({ data: null, /* error: e, */ isLoading: false });
    }
  };

  toggleUpdateModal = () => {
    const { data } = this.state;
    const statusAtulizar = this.nameButtonStatus(data.status.id);

    this.setState(prevState => ({
      openMdStatus: !prevState.openMdStatus,
      updateEntregue: statusAtulizar === 'Entregue'
    }));
  };

  toogleCancelModal = () => {
    this.setState(prevState => ({ cancelModal: !prevState.cancelModal }));
  };

  updateOrderStatus = async () => {
    const { 
      data, 
      nomeRecebedor,
      dataBanco
    } = this.state;
    const { match } = this.props;
    const { id } = match.params;
    const arrStatus = [
      PENDENTE.id,
      PREPARACAO.id,
      PRONTAENTREGA.id,
      ENTREGUE.id,
      AGUARDANDODEVOLUCAO.id,
      DEVOLVIDO.id
    ];

    const index = arrStatus.indexOf(data.status.id) + 1;
    
    const serviceUrl = `Pedido/AtualizaStatus/${id}?status=${arrStatus[index]}&retirouUniforme=${nomeRecebedor}&dataRetiradaUniforme=${dataBanco}`;
  
    this.updateStatus(serviceUrl, index);
  };

  cancelRequest = () => {
    const { match } = this.props;
    const { id } = match.params;
    const {
      nomeRecebedor,
      dataBanco  
    } = this.state;
    const serviceUrl = `/Pedido/AtualizaStatus/${id}?status=${CANCELADO.id}&retirouUniforme=${nomeRecebedor}&dataRetiradaUniforme=${dataBanco}`;
    this.updateStatus(serviceUrl, 5);
  };

  updateStatus = (serviceUrl, indexMsg) => {

    const messages = [
      'Status alterado para preparação',
      'Status alterado para Pronto p/ Entrega',
      'Status alterado para entregue',
      'Status alterado para Devolvido',
      'Pedido Cancelado conforme o solicitado.'
    ];
    pathDmService(serviceUrl, {})
      .then(() => {
        const { history } = this.props;
        toast.success(messages[indexMsg - 1]);

        if (indexMsg <= 4) {
          this.toggleUpdateModal();
          this.loadUniforms();
        } else {
          this.toogleCancelModal();
          history.push('/trade/admin/uniformes/lista/todos');
        }
      })
      .catch(() => {
        toast.warn('Um erro inesperado ocorreu ao tentar modificar o status');
        this.toggleUpdateModal();
      });
  };

  changeTab = ({ index }) => {
    const { match, history } = this.props;
    const route = index === 0 ? 'detalhe' : 'informacoes';
    history.push(`${match.url}/${route}`);
  };

  nameButtonStatus = status => {
    if (status === PENDENTE.id) {
      return PREPARACAO.value;
    }
    if (status === PREPARACAO.id) {
      return PRONTAENTREGA.value;
    }
    if (status === PRONTAENTREGA.id) {
      return ENTREGUE.value;
    }
    if (status === ENTREGUE.id) {
      return AGUARDANDODEVOLUCAO.value;
    }

    if (status === AGUARDANDODEVOLUCAO.id) {
      return DEVOLVIDO.value;
    }
    return false;
  };

  buttonRenderRight(statusIndex) {
    const { data, nivel } = this.state;

    return (
      <div>
        {nivel === 10 && statusIndex <= 1 &&
          data.status.id !== 5 && (
            <button
              className="bx--btn btn-primary-outlined h-sm-margin"
              onClick={this.toogleCancelModal}
              type="submit"
            >
              Cancelar Pedido
            </button>
          )}
        {nivel === 10 && statusIndex <= 4 &&
          data.status.id !== 5 && (
            <button
              className="bx--btn btn-secondary-color h-sm-margin"
              onClick={this.toggleUpdateModal}
              type="submit"
            >
              {this.nameButtonStatus(data.status.id)}
            </button>
          )}
        {data.status.id === 5 && (
          <h3 className="text-warning">Pedido Cancelado</h3>
        )}
      </div>
    );
  }

  onChangeText = event => {
    this.setState({
      nomeRecebedor: event.target.value
    });
  };

  onChangeDate = date => {
    const newDate = date ? moment(date[0]).format('YYYY-MM-DD HH:mm:ss') : date;    
    this.setState({
      dataEntrega:newDate,
      dataBanco: newDate
    })
  };

  render() {
    const {
      data,
      isLoading,
      isUpdating,
      openMdStatus,
      cancelModal,
      updateEntregue,
      dataEntrega,
      nomeRecebedor,
      
    } = this.state;
    const { history } = this.props;
    // const selectedTab = location.pathname.indexOf('detalhe') !== -1 ? 0 : 1;
    const orderStatus = data && data.status;
    const disabledButtonUpdatStatus = updateEntregue && (dataEntrega === "" || nomeRecebedor === "");
    const currentDate = dataEntrega || new Date();
    if (isLoading) {
      return (
        <div>
          <Breadcrumb title="---- - ----" description="----" />

          <section className="content-wrapper content-wrapper--large">
            <ProgressIndicatorSkeleton />
          </section>
        </div>
      );
    }

    const statusIndex = getStatusUniformIndex(
      orderStatus ? orderStatus.id : {}
    );
    return (
      <div>
        {data && (
          <div>
            <Breadcrumb
              title={`${data.numero} - ${
                data.tipo === 'Novo'
                  ? 'Solicitação de Kit'
                  : 'Solicitação de Troca'
              }`}
              description={`Criada por ${data.solicitante.nome}`}
              renderRight={this.buttonRenderRight(statusIndex)}
              renderLeft={(() => (
                <div
                  className="breadcrumb-left-actions pointer"
                  onClick={() => history.goBack()}
                >
                  <svg width="16" height="14" viewBox="0 0 16 14">
                    <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
                  </svg>
                </div>
              ))()}
            />
            <section className="content-wrapper content-wrapper--large">
              <ProgressIndicator
                className="v-xl-margin"
                currentIndex={statusIndex}
              >
                <ProgressStep label="Pendente" />
                <ProgressStep label="Preparação" />
                <ProgressStep label="Pronto p/ Entrega" />
                <ProgressStep label="Entregue" />
                <ProgressStep label="Aguardando Devolução" />
                <ProgressStep label="Devolvido" />
              </ProgressIndicator>

              <Detail data={data} />

              <Modal
                open={openMdStatus}
                onRequestSubmit={this.updateOrderStatus}
                onRequestClose={this.toggleUpdateModal}
                primaryButtonDisabled={disabledButtonUpdatStatus}
                modalHeading="Modificar Status"
                primaryButtonText="Tenho certeza"
                secondaryButtonText="Cancelar"
              >
                {!updateEntregue ? (
                  <div>
                    <p>
                      Você tem certeza que deseja alterar o status do pedido
                      {' '}
                      <strong> 
                        {' '}
                        {data.numero}
                        {' '}
                      </strong>
                      {' de '}
                      <strong>{namesStatus(data.status.id)}</strong>
                      {' para '}
                      <strong> 
                        {' '}
                        {this.nameButtonStatus(data.status.id)}
                        {' '}
                      </strong>
                      ?
                    </p>
                  </div>
                ) : (
                  <div className="bx--row">
                    <div className="v-sm-margin bx--col-md-12">
                      <p>
                        Você tem certeza que deseja alterar o status do pedido
                        {' '}
                        <strong> 
                          {' '}
                          {data.numero}
                          {' '}
                        </strong>
                        {' de '}
                        <strong>{namesStatus(data.status.id)}</strong>
                        {' para '}
                        <strong> 
                          {' '}
                          {this.nameButtonStatus(data.status.id)}
                          {' '}
                        </strong>
                        ?
                      </p>
                    </div>
                    <div className="v-sm-margin bx--col-md-3 bx--col-xs-12">
                      <DatePicker
                        id="date-pickerI"
                        className=""
                        datePickerType="single"
                        dateFormat="d/m/Y"
                        locale="pt"
                        onChange={e => this.onChangeDate(e)}
                        value={moment(currentDate).format("DD/MM/YYYY")}
                      >
                        <div>
                          <DatePickerInput
                            name="dataDesejada"
                            id="dataDesejada"
                            labelText="Data da entrega"
                            pattern="d{1,2}/d{4}"
                            placeholder="dd/mm/aaaa"
                            onChange={e => this.onChangeDate(e)}
                            value={moment(currentDate).format("DD/MM/YYYY")}
                          />
                        </div>
                      </DatePicker>
                    </div>

                    <div className="v-sm-margin  bx--col-md-9 bx--col-xs-12">
                      <label className="bx--label">
                        Recebido por:
                      </label>
                      <input
                        type="razaoSocial"
                        className="bx--text-input"
                        required
                        placeholder="Nome do recebedor"
                        name="razaoSocial"
                        value={nomeRecebedor}
                        onChange={this.onChangeText}
                      />
                    </div>

                  </div>
                )}
              </Modal>

              <Modal
                open={cancelModal}
                onRequestSubmit={this.cancelRequest}
                onRequestClose={this.toogleCancelModal}
                modalHeading="Cancelar Pedido"
                primaryButtonText="Tenho certeza"
                secondaryButtonText="Cancelar"
              >
                <div className="warning-modal-txt">
                  <p>Você tem certeza que deseja cancelar este pedido?</p>
                </div>
              </Modal>
              {isUpdating && <Loading small />}
            </section>
          </div>
        )}
      </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/screens/admin/Trades/Uniforms/Detail/Main.js